<template>
	<div class="education-infos">
		<div class="education-infos--items">
			<Item v-if="education.title">
				<template #label>Bezeichnung der Ausbildung:</template>
				<template #content>{{ education.title}}</template>
			</Item>
			<Item v-if="education.educationCompletion">
				<template #label>Status der Ausbildung:</template>
				<template #content><Label :characteristic="education.educationCompletion"/></template>
			</Item>
			<Item v-if="education.professions && education.professions.length > 0">
				<template #label>Fachliche Schwerpunkte:</template>
				<template #content>
					<LabelList
						:characteristics="extractCharacteristic(education.professions)"
						:label-type="labelTypeApplication"
						last-level-only
					/>
				</template>
			</Item>
			<Item v-if="validityEligible">
				<template #label>Gültigkeit:</template>
				<template #content>
					<template v-if="education.validityDate">
						zeitlich beschränkt bis {{ education.validityDate | dateByObject }}
					</template>
					<template v-else>zeitlich unbeschränkt</template>
				</template>
			</Item>
			<Item v-if="education.start">
				<template #label>Zeitraum:</template>
				<template #content>
					<template v-if="education.end">
						{{ education.start | monthYearByObject }} - {{ education.end | monthYearByObject }}
					</template>
					<template v-else>
						{{ education.start | monthYearByObject }} - aktuell
					</template>
				</template>
			</Item>
			<Item v-if="education.postgraduate !== undefined">
				<template #label>Postgraduale Ausbildung:</template>
				<template #content>{{ education.postgraduate ? 'Ja' : 'Nein'}}</template>
			</Item>
			<Item v-if="education.studyEntitlement !== undefined">
				<template #label>Studienberechtigung:</template>
				<template #content>{{ education.studyEntitlement ? 'Ja' : 'Nein'}}</template>
			</Item>
			<Item v-if="education.educationCompletionType">
				<template #label>Abschluss durch:</template>
				<template #content><Label :characteristic="education.educationCompletionType"/></template>
			</Item>
			<Item v-if="education.gainedTitle">
				<template #label>Erworbener Titel:</template>
				<template #content>{{ education.gainedTitle }}</template>
			</Item>
			<Item v-if="education.schoolLocation">
				<template #label>Ort/e der Ausbildung:</template>
				<template #content>
					<LabelList
						:characteristics="extractCharacteristic(education.schoolLocation)"
						:label-type="labelTypeApplication"
						last-level-only
					/>
				</template>
			</Item>
			<Item v-if="education.instituteName">
				<template #label>Name der Bildungseinrichtung:</template>
				<template #content>{{ education.instituteName }}</template>
			</Item>
			<Item v-if="education.details">
				<template #label>Details:</template>
				<template #content><div v-html="education.details" /></template>
			</Item>
		</div>
	</div>
</template>

<script>
import Label from "@/vue/characteristic/Label.vue";
import LabelList from "@/vue/characteristic/LabelList.vue";
import {APPLICATION} from "@/helper/characteristic/Label";
import * as CharacteristicTag from "@/helper/characteristic/Tag";
import Item from "@/vue/application/education/infos/Item.vue";

export default {
	components: {Item, LabelList, Label},

	props: {
		education: {
			type: Object,
			required: true
		},
	},

	computed: {
		labelTypeApplication ()
		{
			return APPLICATION;
		},
		isEducationCompleted ()
		{
			return this.education.educationCompletion
				&& CharacteristicTag.hasTag(
					this.education.educationCompletion,
					CharacteristicTag.CAREER_EDUCATION_COMPLETED
				);
		},
		validityEligible ()
		{
			return this.isEducationCompleted
				&& CharacteristicTag.hasTag(this.education.schoolType, CharacteristicTag.CAREER_EDUCATION_VALIDITY_ELIGIBLE);
		}
	},

	methods: {
		extractCharacteristic (items)
		{
			return items.map(item => item.item);
		}
	}
}
</script>
